import { Component, input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslocoModule } from '@jsverse/transloco';
import { HighlightDirective } from '../../../global/directives/highlight.directive';
import { IdealVisitDayPill } from '../ideal-visit-day-pill/ideal-visit-day-pill.component';
import { SegmentComponent } from '../segment/segment.component';
import { AccountContract } from '../../store/accounts/types';
import { daysBetweenDates } from '../../utils/days-between-dates';
import { svgIconKeys } from '../../../constants/svg-icon-keys';

@Component({
  selector: 'blindspot-account-search-item',
  styleUrls: ['./account-search-item.component.scss'],
  imports: [
    CommonModule,
    DatePipe,
    SvgIconComponent,
    TranslocoModule,
    HighlightDirective,
    IdealVisitDayPill,
    SegmentComponent,
  ],
  template: `
    <div class="search-item" [class.dark]="variant() === 'dark'">
      <div class="flex-row">
        <div class="flex-row">
          <span class="ellipsis" [blindspotHighlight]="currentSearch()">
            {{ account().name }}
          </span>
          <blindspot-segment
            class="segment"
            [segment]="account().segment.name"
            [priority]="account().segment.priority"
          />
        </div>
        <div class="days">
          <svg-icon svgClass="icon" [src]="svgIconKeys.clock" />
          <span>
            {{
              'daysAgoRule'
                | transloco
                  : {
                      count: daysBetweenDates(today(), account().lastVisitDate),
                    }
            }}
          </span>
        </div>
      </div>
      <div class="flex-row">
        <span class="ellipsis" [blindspotHighlight]="currentSearch()">
          {{
            account().street +
              ', ' +
              account().zipCode +
              ' ' +
              account().city +
              ', ' +
              account().country
          }}
        </span>
        @if (account().nextVisitDate) {
          <div class="next-visit">
            <svg-icon svgClass="icon" [src]="svgIconKeys.calendar" />
            <span>{{ account().nextVisitDate | date: 'dd/MM/yyyy' }}</span>
          </div>
        } @else {
          <blindspot-ideal-visit-day-pill
            [visitDate]="today()"
            [idealNextVisitDate]="account().idealNextVisitDate"
          />
        }
      </div>
    </div>
  `,
})
export class AccountSearchItemComponent {
  public account = input.required<AccountContract>();
  public currentSearch = input.required<string>();
  public today = input.required<Date>();
  public variant = input.required<'light' | 'dark'>();
  protected readonly daysBetweenDates = daysBetweenDates;
  protected readonly svgIconKeys = svgIconKeys;
}
